import {
  PrivacyBanner as CentivoPrivacyBanner,
  PrivacyBannerProps,
} from '@centivo/react-components'
import styled, { css } from 'styled-components'

const PrivacyBannerContainer = styled.div`
  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
      case 'template-eligibility':
        return css`
          & > div {
            background-color: ${theme.palette.brand.darkGreen};
            padding: 1.5rem 2.5rem 2.25rem 2.5rem;

            .banner--content {
              color: ${theme.palette.neutral.white};

              font-size: 0.875rem;
              line-height: 1.26rem;
              font-weight: 500;

              p {
                margin: 0;

                a {
                  color: ${theme.palette.brand.lightGreen};
                }

                a:hover {
                  color: ${theme.palette.brand.lightGreen};
                }
              }

              .banner--dismiss {
                font-size: 0.875rem;
                line-height: 1.26rem;
                font-weight: 500;

                color: ${theme.palette.brand.lightGreen};
              }

              .banner--dismiss:hover {
                color: ${theme.palette.brand.lightGreen};
              }

              .icon-centivo--x,
              .icon-centivo--x:hover {
                color: ${theme.palette.brand.beige};
              }
            }
          }
        `

      default:
        return {}
    }
  }}
`

export const PrivacyBanner: React.FC<PrivacyBannerProps> = props => {
  return (
    <PrivacyBannerContainer>
      <CentivoPrivacyBanner zIndex={1} {...props} />
    </PrivacyBannerContainer>
  )
}
